export default __webpack_public_path__ + "static/media/mccann-logo.7a30767f.svg";